export enum SalesChannel {
  Instore = 'InStore',
  Online = 'Online',
  Both = 'Both',
}
